import { render } from "./OffCanvasCrew.vue?vue&type=template&id=01783075&scoped=true"
import script from "./OffCanvasCrew.vue?vue&type=script&lang=js"
export * from "./OffCanvasCrew.vue?vue&type=script&lang=js"

import "./OffCanvasCrew.vue?vue&type=style&index=0&id=01783075&scoped=true&lang=css"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/mbsm-pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01783075"]])

export default __exports__